module.exports = __webpack_public_path__ + "img/person_type3.13bf281e.png";